import React,{useRef,useEffect,useState, useCallback} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { createTheme, List } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import axios from 'axios'
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';
import Paper from '@mui/material/Paper';
import ListItem from '@mui/material/ListItem';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';


import AddProducts from './AddHighlightProducts';

const drawerWidth = 300;



const materialTheme = createTheme(({
    // set default for now
  }));


const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    appBar: {
        position: 'fixed',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
  fullWidth: {
    width: "100%"
  },
  productListPaper: {
  
    marginBottom: 50,
  },
  
  paper: {
    padding: theme.spacing(1),
    textAlign: 'right',
    color: theme.palette.text.secondary,
  },
  appBarBottom: {
    top: 'auto',
    bottom: 0,
    [theme.breakpoints.up('sm')]: {
      },
  },
  grow: {
    flexGrow: 1,
  },
}));



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const HighlightSkuSettings = (props) => {
    const classes = useStyles();
    const [isSavingSettings, setIsSavingSettings] = useState(false)
    const [showMessageDialog,setShowMessageDialog] = useState(false)
    const [messageDialogMessage,setMessageDialogMessage] = useState("")
    const [isSavingSuccess,setIsSavingSuccess] = useState(false)
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingProduct, setIsLoadingProduct] = useState(true)
    const [selectedProduct, setSelectedProduct] = useState(null)
    const [productInfoAnchorElement, setProductInfoAnchorElement] = useState(null)
    const [searchTerm, setSearchTerm] = useState({name : ""})
    const [openAddHighLightedProduct, setOpenAddHighLightedProduct] = useState(false);
    const [autoSuggestProducts, setAutoSuggestProducts] = useState([]);
    const [products,setProducts] = useState([]);
    const [pageNumber,setPageNumber] = useState(1)
    const [hasMoreProductToLoad,setHasMoreProductToLoad] = useState(true)
    const [autoCompleteSearchOptionMessage, setAutoCompleteSearchOptionMessage] = useState("Product not found.")
    const [showDeleteProductDialog, setShowDeleteProductDialog] = useState(false)
    const [actionMessage, setActionMessage] = useState("");
    const [showProgressDialog, setShowProgressDialog] = useState("");
    
    const lastProductElementObserver = useRef()
    const lastProductElement = useCallback(node=>{
      if(isLoading){
          return
      }
      if(lastProductElementObserver.current){
        lastProductElementObserver.current.disconnect()
      }
      lastProductElementObserver.current = new IntersectionObserver(entries=>{
        if(entries[0].isIntersecting && hasMoreProductToLoad){
          
          lastProductElementObserver.current.disconnect()
          setPageNumber(prevPageNumber => prevPageNumber + 1)
          setIsLoadingProduct(true)
        }
  
      })
      
      if(node){
        lastProductElementObserver.current.observe(node)
      }
    },[isLoadingProduct, hasMoreProductToLoad])

    const progressDialog = () => {
        return(
          <Dialog
          fullWidth={true}
          maxWidth={'lg'}
          open={showProgressDialog}
          onClose={()=>{}}
        >
         
          <DialogContent>
            <DialogContentText>
             {actionMessage}
            </DialogContentText>
            <LinearProgress color="secondary" />
          </DialogContent>
        </Dialog>
        )
    }
    
    const messageDialog = () => {
        return(
            <Dialog
            fullWidth={true}
            maxWidth={'sm'}
            open={showMessageDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
               {messageDialogMessage}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={()=>{
                
                
                  setShowMessageDialog(false)
  
                  if(isSavingSuccess){
                    

                  }
                  
                  }} 
                color="primary" autoFocus>
                Close
              </Button>
            </DialogActions>
          </Dialog>
          )
    }
    
    const menuHandleClose = () => {
      setShowDeleteProductDialog(false)
    };

    const handleDeleteProducts = () =>{
      
      const options = {
        method: 'POST',
        url: '/TransactiLiteAndSellerHighlightSku/deleteHighlightSku.json',
        data: objectToFormData({product_code:selectedProduct.code})
      }

      axios(options)
      .then((res) => {

        setShowProgressDialog(false)
        setMessageDialogMessage(res.data.response.message)
        setShowMessageDialog(true)


        props.fetchTotalSKus()
        const is_success = res.data.response.is_success;
        
        if (is_success) {
          setProducts([])
          setPageNumber(1)
          setIsLoadingProduct(true)
        }

      })
      .catch(error => {
        setMessageDialogMessage(error)
        setShowMessageDialog(true)
      }) 
    }

    const deleteSkuDialog = () => {
      return(
          <Dialog
          fullWidth={true}
          maxWidth={'sm'}
          open={showDeleteProductDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
             {messageDialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>

            <Button onClick={()=>{
                menuHandleClose()
                setActionMessage("Deleting Product... Please wait...")
                setShowProgressDialog(true)
                setShowDeleteProductDialog(false)
                handleDeleteProducts()
              }} 
              color="error" autoFocus>
              DELETE
            </Button>

            <Button onClick={()=>{
                setShowDeleteProductDialog(false)
                }} 
              color="primary" autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        )
  }

    const highlightedProductsLists = () => {
      return (
       <List>
          {
            products.map((product, index) => (
              (products.length === index + 1) ? 
              (
                <React.Fragment key={index+product.id+product.name} >
                  <ListItem ref={lastProductElement} key={index+product.id+product.name} divider >
                    {productElement(product)}
                    
                    <IconButton size="large" 
                        onClick={
                            (event)=>{
                                setSelectedProduct(product)
                                setProductInfoAnchorElement(event.currentTarget)
                                setShowDeleteProductDialog(true)
                                setMessageDialogMessage("Are you sure you want to delete " +product.name+ "?")
                              }
                            }>
                        <DeleteIcon/>
                      </IconButton>
                  </ListItem>
                </React.Fragment>
              )
              : 
              (
                <React.Fragment key={index+product.id+product.name}>
                  <ListItem key={index+product.id+product.name} divider  style={{ boxShadow: 'none !important' }}>
                    {productElement(product)}
                      <IconButton size="large" 
                        onClick={
                            (event)=>{
                                setSelectedProduct(product)
                                setProductInfoAnchorElement(event.currentTarget)
                                setShowDeleteProductDialog(true)
                                setMessageDialogMessage("Are you sure you want to delete " +product.name+ "?")
                              }
                            }>
                              
                        <DeleteIcon/>
                      </IconButton>
                  </ListItem>
               </React.Fragment>
              )
            ))
          }
       </List>
      )
    }

    const productElement = (product) => {
        return (
          <Grid container style={{padding:"0px"}}>
            <Grid container item xs={12} >
              < Grid item xs={3} md={2} lg={1} style={{padding:"4px"}} container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center">
                <img src={product.image} alt="" style={{ width:"100%"}} />
              </Grid>
              <Grid item xs={9} md={10} lg={11}>
                <Grid 
                container
                direction="column"
                justifyContent="space-between"
                alignItems="stretch">
                    <Grid item >
                      <Box style={{ fontWeight:600,fontSize:"15px" }}>{product.code}</Box>
                      <Box style={{ fontWeight:600,fontSize:"14px" }}>{product.brand}</Box>
                      <Box style={{ fontWeight:600,fontSize:"14px" }}>{product.name}</Box>
                    </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        );
    }
    
    useEffect(()=>{

      const fetchHighlightedProductSuggestions = async () => {
        try {
          
          const options = {
            method: 'POST',
            url: '/TransactiSellerProducts/getProductsForAutoSuggest.json',
            data: objectToFormData({search_term:searchTerm.name})
          }

          setIsLoading(true)
          await axios(options)
          .then(response => {

            const suggested_products = response.data.products
            setAutoSuggestProducts(suggested_products)
            setIsLoading(false)
          })
          .catch(error => {
            setMessageDialogMessage(error)
            setShowMessageDialog(true)
            setIsLoading(false)
          })

        } catch (error) {
          setMessageDialogMessage(error)
          setShowMessageDialog(true)
          setIsLoading(false)
        }
      }

      fetchHighlightedProductSuggestions()

    },[searchTerm.name])

    useEffect(() => {
      if(!isLoadingProduct){
        return
      }

      const fetchProducts = async () => {

        const options = {
          method: 'POST',
          url: '/TransactiLiteAndSellerHighlightSku/getHighlightedSkus.json',
          data: objectToFormData({search_term:searchTerm.name,page_number:pageNumber})
        }

        await axios(options)
        .then(res => {

          setIsLoadingProduct(false)
          const isSuccess = res.data.response.is_success
          if(!isSuccess){
            setMessageDialogMessage(res.data.response.message)
            setShowMessageDialog(true)
            setIsLoadingProduct(false)
          }

          
          const productsFromServer = res.data.response.products
          setHasMoreProductToLoad(productsFromServer.length > 0)
          setProducts(products.concat(productsFromServer))
        })
        .catch(error => {
          setMessageDialogMessage(error)
          setShowMessageDialog(true)
          setIsLoading(false)
          setIsLoadingProduct(false)
        })

      }

      fetchProducts()
    },[isLoadingProduct, searchTerm.name])
    
    function search(){
      return (
        <div position="static" style={{border:".1rem solid #989898",borderRadius:"4px",margin:'2px'}}>
            <Toolbar variant="dense" style={{padding:'0'}}>
                <Box flexGrow={1}>{autoComplete()}</Box>
                <Box>
                <IconButton 
                  className={classes.margin} 
                  size="large"
                  onClick={
                    ()=>{
                      setProducts([])
                      setPageNumber(1)
                      setIsLoadingProduct(true)
                     }
                  }>
                <SearchIcon />
                </IconButton>
                </Box>
            </Toolbar>
        </div>
      );
    }  

    const autoComplete = () => {
      return (
        <Autocomplete
              value={searchTerm}
              noOptionsText={autoCompleteSearchOptionMessage}
              onChange={(event, newValue) => {
               
              
                if(newValue==null || newValue.name===""){
                  searchTerm.name = ""
                  return
                }
                searchTerm.name = newValue.name
                setProducts([])
                setPageNumber(1)
                setIsLoadingProduct(true)
              }}
              
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              options={autoSuggestProducts}
              isOptionEqualToValue={(option, value) =>true}
              getOptionLabel={(option) => {
                 
                    return option.name;
              }}
              renderOption={(props, option) => {
                return (
                  <li {...props} key={option.name}>
                    {option.name}
                  </li>
                );
              }}
              style={{ width: '100%',paddingLeft:'8px'}}
              renderInput={(params) => (
                <TextField
                 {...params}
                 variant='standard'  
                 InputProps={{...params.InputProps, disableUnderline: true}}  
                 
                onChange={(event)=>{ 
                  setSearchTerm({name:event.target.value})
                
                }
                } />
              )}
        />
      )
    }

    const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);
      return formData;
    }, new FormData());


    return (
        <div>
           <Dialog 
            fullScreen 
            open={props.openDialogSettings} 
            onClose={()=>{props.setSelectedSettings({name:""})}} 
            TransitionComponent={Transition}
            >
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={()=>{
                            
                            props.setOpenDialogSettings(false)
                            
                        }
                            
                            
                        }
                        aria-label="close"
                        size="large">
                    <CloseIcon />
                    </IconButton>
                    <Typography variant="subtitle1" className={classes.title}>
                       {"Highlight SKUs"}
                    </Typography>
                </Toolbar>
            </AppBar>
            <div className={classes.appBarSpacer}></div>
            <Paper square className={classes.productListPaper}>
                {search()}
                {isLoading ? <LinearProgress color="secondary"  style={{marginLeft:'.1rem',marginRight:'.1rem'}}/> : ''}
                {highlightedProductsLists()}
              
            </Paper>
            <AppBar position="fixed" color="primary" className={classes.appBarBottom}>
                {isLoadingProduct ? <LinearProgress color="secondary"  style={{marginLeft:'.1rem',marginRight:'.1rem'}}/> : ''}
            </AppBar>
            <AppBar position="fixed"  style={{ background: 'transparent', boxShadow: 'none'}} className={classes.appBarBottom}>
                <Toolbar>
                
                  <div className={classes.grow} />
                  
                  <Fab
                    variant="extended"
                    size="medium"
                    color="primary"
                    aria-label="add"
                    className={classes.margin}
                    onClick={()=>{
                      setOpenAddHighLightedProduct(true)
                    }}
                  >
                    <AddIcon className={classes.extendedIcon} />
                    Add Highlight Product
                  </Fab>
                    </Toolbar>
            </AppBar>
            {
              openAddHighLightedProduct && (
                <AddProducts
                  openAddHighLightedProduct = {openAddHighLightedProduct}
                  setOpenAddHighLightedProduct = {setOpenAddHighLightedProduct}
                  setIsLoadingProduct = {setIsLoadingProduct}
                  setPageNumber = {setPageNumber}
                  setProducts = {setProducts}
                  fetchTotalSKus = {props.fetchTotalSKus}
                />
              )
            }
      </Dialog>
      <StyledEngineProvider injectFirst>
          <ThemeProvider theme={materialTheme}>
            {progressDialog()}
            {messageDialog()}
            {deleteSkuDialog()}
            </ThemeProvider>
      </StyledEngineProvider>
        </div>
    );
}

export default HighlightSkuSettings